import Icon from '../components/Icon.vue'

Icon.register({
  'praying-hands': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M272 191.9c17.6 0 32 14.4 32 32v128c0 51.9-34.8 98.1-84.8 112.3l-179.2 46.6c-2.6 0.7-5.4 1-8.1 1-23.5 0-32-21.2-32-32v-96 0c0-12.7 9.8-26.3 21.9-30.3l90.1-30v-80.2c0-19 5.6-37.4 16.1-53.2l117.3-175.9c0.2-0.3 0.6-0.3 0.8-0.5 9.6-13.5 27.8-17.9 42.3-9.2 15.2 9.1 20.1 28.8 11 43.9l-77.8 129.6c-9 14.9-13.7 32-13.7 49.4v76.5c0 8.8 7.2 16 16 16s16-7.2 16-16v-80c0-17.6 14.4-32 32-32zM618.1 353.6c13.1 4.4 21.9 16.6 21.9 30.4v96c0 10.8-8.5 32-32 32-2.7 0-5.4-0.3-8.1-1l-179.2-46.6c-49.9-14.3-84.8-60.5-84.8-112.3v-128c0-17.6 14.4-32 32-32s32 14.4 32 32v80c0 8.8 7.2 16 16 16s16-7.2 16-16v-76.5c0-17.4-4.7-34.5-13.7-49.4l-77.8-129.6c-9.1-15.2-4.2-34.8 11-43.9 14.5-8.7 32.7-4.3 42.3 9.2 0.2 0.2 0.6 0.2 0.8 0.5l117.3 175.9c10.6 15.8 16.1 34.3 16.1 53.2v80.2z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/praying-hands.js
// module id = 1660
// module chunks = 0